// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class ImageUrlSizes extends Immutable.Record({
  small: String(),
  medium: String(),
  large: String()
}) {
  // No methods
}

ImageUrlSizes.reviver = keyedReviver(ImageUrlSizes, {
  // No nested data structures
})

ImageUrlSizes.propTypes = {
  small: PropTypes.string,
  medium: PropTypes.string,
  large: PropTypes.string
}

module.exports = ImageUrlSizes
